/**
 * Стек открытых модалок.
 *
 * Нужен ровно для Escape. Обработчик каждой модалки висит на `window`, поэтому
 * при двух открытых модалках (кадрирование поверх заявки команды) одно нажатие
 * доходит до обоих слушателей и закрывает обе сразу — `stopPropagation` тут не
 * помогает, слушатели сидят на одном узле. Верхней считается та, что открылась
 * последней: только её обработчик пропускает `when`.
 *
 * Модуль намеренно без React: регистрация происходит в эффекте `UDModal`, а
 * состояние стека никто не рендерит.
 */

const stack: symbol[] = [];

/** Кладёт модалку наверх стека. Повторный вызов с тем же id ничего не меняет. */
export function pushModal(id: symbol): void {
  if (stack.includes(id)) return;
  stack.push(id);
}

/** Убирает модалку из стека — с любой позиции: закрыть могут и нижнюю. */
export function removeModal(id: symbol): void {
  const index = stack.indexOf(id);
  if (index !== -1) stack.splice(index, 1);
}

/** Верхняя ли это модалка. Пустой стек — считаем, что да: слушателя всё равно нет. */
export function isTopModal(id: symbol): boolean {
  return stack.length === 0 || stack[stack.length - 1] === id;
}

/** Только для тестов: стек живёт в модуле и переживает размонтирование. */
export function resetModalStack(): void {
  stack.length = 0;
}
